import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCookies } from 'react-cookie';
import { domain, LocationCookie, ZipCodeCookie, PersistentZipCodeCookie } from '../utils/constants';
import { validateZipCode } from '../utils/queries';
import * as locationParser from '../utils/locationParser';
import { useMemo, useCallback, useContext } from 'react';
import { useQuery } from '@apollo/client';
import { ZipcodeContext } from './ZipcodeProvider';
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$withCity = _ref.withCity,
    withCity = _ref$withCity === void 0 ? false : _ref$withCity;
  var initialZipInfo = useContext(ZipcodeContext);
  var _useCookies = useCookies([LocationCookie]),
    _useCookies2 = _slicedToArray(_useCookies, 2),
    cookies = _useCookies2[0],
    setCookie = _useCookies2[1];
  var locationCookieValue = cookies[LocationCookie];
  var parsedCookieValue = useMemo(function () {
    return locationParser.decode(locationCookieValue);
  }, [locationCookieValue]);
  var FIRST_DATE = new Date(0);
  var updateGlobalZip = useCallback(function (newGlobalZipInfo) {
    var cookieValue = locationParser.encode(newGlobalZipInfo);
    setCookie(LocationCookie, cookieValue, {
      domain: domain,
      path: '/'
    });
    setCookie(ZipCodeCookie, newGlobalZipInfo.zip, {
      expires: FIRST_DATE
    });
    setCookie(PersistentZipCodeCookie, newGlobalZipInfo.zip, {
      expires: FIRST_DATE
    });
    var cookieAge = 60 * 60 * 24 * 30;
    var now = new Date();
    var expirationDate = new Date(now.valueOf() + cookieAge * 1000);
    var cookieOptionsForZipCode = {
      path: '/',
      maxAge: cookieAge,
      expires: expirationDate
    };
    setCookie(ZipCodeCookie, newGlobalZipInfo.zip, cookieOptionsForZipCode);
    setCookie(PersistentZipCodeCookie, newGlobalZipInfo.zip, cookieOptionsForZipCode);
  }, [setCookie]);
  var _useQuery = useQuery(validateZipCode, {
      skip: !withCity || !parsedCookieValue.zip || (initialZipInfo === null || initialZipInfo === void 0 ? void 0 : initialZipInfo.zip) === parsedCookieValue.zip,
      ssr: true,
      variables: {
        zipcode: parsedCookieValue.zip
      }
    }),
    data = _useQuery.data,
    loading = _useQuery.loading;
  var globapZipInfo = useMemo(function () {
    var _data$locationInfoByZ, _data$locationInfoByZ2, _data$locationInfoByZ3, _data$locationInfoByZ4;
    return _objectSpread(_objectSpread({}, parsedCookieValue), (initialZipInfo === null || initialZipInfo === void 0 ? void 0 : initialZipInfo.zip) === parsedCookieValue.zip ? initialZipInfo : {
      city: data === null || data === void 0 || (_data$locationInfoByZ = data.locationInfoByZip) === null || _data$locationInfoByZ === void 0 ? void 0 : _data$locationInfoByZ.city,
      county: data === null || data === void 0 || (_data$locationInfoByZ2 = data.locationInfoByZip) === null || _data$locationInfoByZ2 === void 0 ? void 0 : _data$locationInfoByZ2.county,
      subCounty: data === null || data === void 0 || (_data$locationInfoByZ3 = data.locationInfoByZip) === null || _data$locationInfoByZ3 === void 0 ? void 0 : _data$locationInfoByZ3.subCounty,
      isMajorMarket: data === null || data === void 0 || (_data$locationInfoByZ4 = data.locationInfoByZip) === null || _data$locationInfoByZ4 === void 0 ? void 0 : _data$locationInfoByZ4.isMajorMarket
    });
  }, [parsedCookieValue, data, loading]);
  return {
    loading: loading,
    globalZip: globapZipInfo.zip,
    userInputZip: globapZipInfo.zip,
    globalZipInfo: globapZipInfo,
    updateGlobalZip: updateGlobalZip
  };
});